var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-card',{attrs:{"byContent":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('content-movement',{attrs:{"movement":_vm.movement,"isParentMethodPriority":true}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }